import logo from './logo.svg';
import './App.css';
import CaloriePage from "./components/caloriePage"
import Header from "./components/header"

function App() {
  return (
    <div className="App">
    <Header />
    <CaloriePage />
    

      
    </div>
  );
}

export default App;
